import { IDME_COOKIES } from '../../constants/localStorageTypes'
import { MODULES, FEATURES } from '../../constants/template-info'
import eraseCookie from '../../utils/eraseCookie'
import getCookie from '../../utils/getCookie'
import isBrowser from '../../utils/isBrowser'
import { captureException } from '../../utils/sentryUtil'

const IDME_DISCOUNT_EXPIRY_TIME = 86400000

export const getIdmeDiscountCode = (): string | undefined => {
  if (isBrowser()) {
    const couponCodeString = getCookie(IDME_COOKIES.IDME_USER_DETAILS)
    if (couponCodeString) {
      const timeStamp = JSON.parse(couponCodeString).timeStamp
      if (Date.now() - timeStamp < Number(IDME_DISCOUNT_EXPIRY_TIME)) return JSON.parse(couponCodeString).discountCode
      else eraseCookie(IDME_COOKIES.IDME_USER_DETAILS)
    }
  }
}

export const getUpdatedUrl = (url: string) => {
  const slidCookie = getCookie('slid')
  if (!slidCookie) return url
  try {
    const parsedCookie = JSON.parse(slidCookie)
    const parsedUrl = new URL(url)
    parsedUrl.searchParams.set('slid', parsedCookie.slid)
    return parsedUrl.href
  } catch (e) {
    return url
  }
}

const getReferralCouponCodeFromLocalStorage = (): string | undefined => {
  const couponCodeString = window.localStorage.getItem('referralCouponCode')
  if (couponCodeString) {
    return JSON.parse(couponCodeString).code
  }
  return undefined
}

const getFirstPurchaseCouponCodeFromLocalStorage = (): string | undefined => {
  const couponCodeString = window.localStorage.getItem('firstPurchaseCouponCode')
  if (couponCodeString) {
    return JSON.parse(couponCodeString).code
  }
  return undefined
}

export const getDiscountCodeIfPresentFromLocalStorage = (): string | undefined => {
  try {
    const referralCouponCode = getReferralCouponCodeFromLocalStorage()
    if (referralCouponCode) {
      return referralCouponCode
    }
    const idmeDiscountCode = getIdmeDiscountCode()
    if (idmeDiscountCode) {
      return idmeDiscountCode
    }
    return getFirstPurchaseCouponCodeFromLocalStorage()
  } catch (error) {
    captureException(error, {
      module: MODULES.CHECKOUT,
      feature: FEATURES.DISCOUNT_CODE,
      extraInfo: {
        capturedFrom: 'getDiscountCodeIfPresentFromLocalStorage from ShopifyCheckoutService',
      },
    })
    return undefined
  }
}
